module.exports = __webpack_public_path__ + "img/upload.e7c2da68.png";